export const SelectWithInputDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'SelectWithInput' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'documentMetadataPairsDistinctValuesForProperty' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'propertyName' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
                            },
                            { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '5000' } },
                            { kind: 'Argument', name: { kind: 'Name', value: 'offset' }, value: { kind: 'IntValue', value: '0' } },
                        ],
                    },
                ],
            },
        },
    ],
};
